import * as yup from 'yup';
import {
  FieldNecessity,
  RequiredProfileInfo,
} from 'modules/corporate-settings/constants/requiredFields';
import { TShortProfileFieldInfoImt } from 'modules/corporate-settings/interfaces';
import { getRequiredErrorMessage } from 'common/utils/validation';

export const getAllergiesValidationSchema = (requiredFields: TShortProfileFieldInfoImt) => {
  return {
    allergies: yup
      .array()
      .of(
        yup.object().shape({
          id: yup.string(),
        }),
      )
      .when('allergies1', {
        is: () => {
          return requiredFields.get(RequiredProfileInfo.Allergies) === FieldNecessity.Required;
        },
        then: schema => schema.min(1, getRequiredErrorMessage),
        otherwise: schema => schema,
      }),
  };
};
